export default __webpack_public_path__ + "static/media/Shooter.7913ba7c.svg";